/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type SystemMessageLevel = (typeof SystemMessageLevel)[keyof typeof SystemMessageLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SystemMessageLevel = {
  info: 'info',
  warning: 'warning',
} as const;
